<template>
	<input
		class="player-name-input border-m input-dark new-player-class"
		type="input"
		autocomplete="off"
		spellcheck="false"
		required
		:value="modelValue"
		@input="updateValue"
	/>
</template>

<script>
export default {
	props: ["modelValue"],
	methods: {
		updateValue(e) {
			this.$emit("update:modelValue", e.target.value);
		},
	},
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/input.scss";

input.player-name-input {
	padding: 0.8em 1em;
	font-size: 1.15em;
}
</style>
